import { render, staticRenderFns } from "./Boards.vue?vue&type=template&id=00198096&scoped=true"
import script from "./Boards.vue?vue&type=script&lang=js"
export * from "./Boards.vue?vue&type=script&lang=js"
import style0 from "./Boards.vue?vue&type=style&index=0&id=00198096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00198096",
  null
  
)

export default component.exports